import c from 'classnames'
import styles from './Icon.module.css'

interface IProps {
  fill?: string
  className?: string
  variant?:
    | 'white'
    | 'black'
    | 'max'
    | 'dark'
    | 'light'
    | 'lighter'
    | 'min'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'positive'
    | 'negative'
    | 'warning'
    | 'panda'
    | 'pandaDark'
    | 'flamingo'
    | 'cocodrile'
    | 'pig'
    | 'koala'
    | 'parrot'
    | 'parrotLight'
    | 'octupus'
  size?: 'xs' | 's' | 'm' | 'l' | 'xl'
  display?: 'inline-block' | 'inline'
}

const IconSettings = ({ fill, className, variant, size = 's', display, ...rest }: IProps) => {
  return (
    <i
      className={c(
        styles.icon,
        variant && styles[variant],
        size && styles[size],
        display && styles[display],
        className,
      )}
      style={{ fill }}
      {...rest}
    >
      <svg viewBox="0 0 30 30">
        <path d="M17.605 29.99c.35-.058.588-.328.644-.697l.224-1.621c.645-.17 1.275-.427 1.905-.697l1.177 1.08c.252.257.602.3.952.114.294-.184.42-.511.35-.88l-.322-1.593a13.35 13.35 0 001.555-1.308l1.456.625c.35.143.672.072.939-.255.238-.256.266-.626.07-.939L25.7 22.44c.378-.554.7-1.151.995-1.777l1.61.071a.748.748 0 00.785-.526c.112-.355.014-.696-.28-.924l-1.261-1.01a11.65 11.65 0 00.364-2.018l1.513-.497c.35-.128.574-.398.574-.768s-.224-.64-.574-.768l-1.513-.497a11.924 11.924 0 00-.364-2.019l1.26-1.01a.81.81 0 00.28-.91.748.748 0 00-.784-.525l-1.61.057a13.69 13.69 0 00-.995-1.777l.855-1.38a.738.738 0 00-.07-.923c-.267-.313-.589-.399-.939-.256l-1.456.61a15.077 15.077 0 00-1.555-1.307l.322-1.578c.07-.384-.056-.71-.35-.881-.35-.185-.686-.157-.952.113l-1.177 1.067a13.97 13.97 0 00-1.905-.697L18.25.704c-.056-.37-.294-.626-.644-.697-.378-.043-.7.114-.84.412l-.757 1.464a12.211 12.211 0 00-2.03 0L13.235.42c-.154-.298-.476-.455-.854-.412-.35.071-.588.327-.644.697l-.224 1.606c-.645.185-1.275.412-1.891.697L8.445 1.94c-.28-.27-.616-.298-.952-.113-.308.17-.434.497-.364.881l.336 1.578c-.546.384-1.078.839-1.555 1.308l-1.47-.611c-.35-.143-.672-.057-.939.256a.758.758 0 00-.07.91l.855 1.393a15.568 15.568 0 00-.995 1.777l-1.61-.057c-.35-.029-.659.185-.785.526-.112.355-.014.682.28.91l1.261 1.009c-.168.654-.308 1.322-.35 2.019l-1.527.497c-.35.114-.56.384-.56.768s.21.654.56.768l1.527.497c.042.697.182 1.38.35 2.019l-1.26 1.01c-.28.227-.379.568-.28.923.125.342.434.555.784.526l1.61-.07c.294.625.617 1.222.995 1.776l-.855 1.38c-.196.312-.168.682.07.938.267.327.589.398.939.255l1.47-.625c.477.483 1.009.924 1.555 1.308l-.336 1.592c-.07.37.056.697.364.881.336.185.686.143.952-.113l1.163-1.08c.63.27 1.26.525 1.905.696l.224 1.62c.056.37.294.64.658.697a.777.777 0 00.84-.426l.743-1.465c.35.029.672.057 1.022.057.336 0 .658-.028 1.008-.057l.757 1.465c.14.312.462.483.84.426zm8.04-15.923h-7.27c-.63-1.706-1.89-2.644-3.417-2.644-.238 0-.49.028-.91.128l-3.726-6.469A10.45 10.45 0 0115 4.002c5.714 0 10.196 4.393 10.644 10.065zM8.612 23.862c-2.633-1.99-4.3-5.203-4.3-8.857 0-3.696 1.71-6.952 4.384-8.942l3.754 6.511c-.7.768-1.036 1.592-1.036 2.474 0 .853.308 1.635 1.036 2.43l-3.838 6.384zm6.359-7.194c-.84 0-1.61-.739-1.61-1.634 0-.91.77-1.621 1.61-1.621.896 0 1.639.71 1.639 1.62 0 .896-.743 1.635-1.639 1.635zM15 25.994c-1.737 0-3.347-.398-4.776-1.123l3.824-6.34c.406.1.672.128.91.128 1.54 0 2.801-.967 3.417-2.701h7.27c-.449 5.644-4.93 10.036-10.645 10.036z" />
      </svg>
    </i>
  )
}

export default IconSettings
